<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  {{ data ? 'Edit ' : 'New ' }} Group
</h1>
<div mat-dialog-content>
  <mat-form-field>
    <mat-label>Group Interface</mat-label>
    <mat-select
      (selectionChange)="groupInterfaceChanged($event)"
      [formControl]="groupInterfaceForm"
    >
      <mat-option *ngFor="let value of groupInterfaces" [value]="value">{{
        getTypeName(value)
      }}</mat-option>
    </mat-select>
  </mat-form-field>
  <ng-container *ngIf="isEmailGroup()">
    <app-marketing-campaign-group-email-form
      [groupInterface]="groupInterface"
      [data]="data?.group"
      [initialValues]="data?.group?.members || []"
      [formSnapshots]="formSnapshots"
      [close]="close.bind(this)"
      (saved)="saved($event)"
    ></app-marketing-campaign-group-email-form>
  </ng-container>
  <ng-container *ngIf="!isEmailGroup()">
    <app-marketing-campaign-group-ids-form
      [groupInterface]="groupInterface"
      [label]="label"
      [items]="items"
      [data]="data?.group"
      [selectedIds]="selectedIds"
      [itemCount]="itemCount"
      [initialValues]="initialValues"
      [selectedItemsCount]="selectedItemsCount"
      [formSnapshots]="formSnapshots"
      [close]="close.bind(this)"
      (loadItems)="loadEvent($event)"
      (saved)="saved($event)"
    ></app-marketing-campaign-group-ids-form>
  </ng-container>
</div>
